import React from 'react'

const Policy = () => {
  return (
    <>
    <h1>
    Privacy Policy
    </h1>

    <p>
      Last updated: February 19, 2022
    </p>

    <p>
    Your privacy is very important to us. Accordingly, we have developed this Policy in order for you to understand how we collect, use, communicate and disclose and make use of personal information. The following outlines our privacy policy.
    </p>

    <ul>
      <li>
      Before or at the time of collecting personal information, we will identify the purposes for which information is being collected.      </li>

      <li>
      Personal information we collect includes email addresses, which we may share with third parties for email marketing purposes.      </li>

      <li>
      We will collect and use of personal information solely with the objective of fulfilling those purposes specified by us and for other compatible purposes, unless we obtain the consent of the individual concerned or as required by law.      </li>

      <li>
      We will only retain personal information as long as necessary for the fulfillment of those purposes      </li>

      <li>
      We will collect personal information by lawful and fair means and, where appropriate, with the knowledge or consent of the individual concerned.      </li>

      <li>
      Personal data should be relevant to the purposes for which it is to be used, and, to the extent necessary for those purposes, should be accurate, complete, and up-to-date.      </li>

      <li>
      Personal data should be relevant to the purposes for which it is to be used, and, to the extent necessary for those purposes, should be accurate, complete, and up-to-date.      </li>

      <li>
      We will make readily available to customers information about our policies and practices relating to the management of personal information.      </li>

  
    </ul>

    <p>
      Contact Us: {`customerservice@${window.location.hostname}.com`}
    </p>
    </>
  )
}

export default Policy